
const ResourceVaultData = [
    {
        id: 1,
        heading: "Everything I Needed in One Place",
        text: "I used to search random blogs and WhatsApp groups for prep advice. The Vault had it all—visa checklists, planners, even career guides. It saved me hours and gave me peace of mind.",
        name: "Aisha, UAE | Headed to University of Toronto"
    },
    {
        id: 2,
        heading: "I Downloaded It Before My Flight",
        text: "The night before I flew out, I grabbed everything from the Vault—packing guide, airport checklist, housing tips. It felt like having a personal assistant.",
        name: "Hamad, Saudi Arabia | Studying in Melbourne"
    },
    {
        id: 3,
        heading: "I Shared It with My Study Group",
        text: "Our whole Gulf student WhatsApp group uses the Vault now. We compare planners, prep for interviews, and even downloaded the mentorship guide together.",
        name: "Fatima, Oman | Law Student in London"
    },
    {
        id: 4,
        heading: "It Helped Me Stay Organized Abroad",
        text: "I still use the academic planner from the Vault every week. It keeps me on track with assignments and deadlines. I even printed it out.",
        name: "Khalid, Bahrain | Business Major in Sydney"
    },
    {
        id: 5,
        heading: "It’s My Go-To Resource Hub",
        text: "Whenever I need something—career tips, visa info, or study tools—I check the Vault first. It’s updated monthly and actually useful for Gulf students like me.",
        name: "Layla, Qatar | Computer Science, University of Leeds"
    },
    
];

export default ResourceVaultData;